import * as R from 'ramda'

export function getItemCategoryOptions<T extends { category?: string; categories?: string[] }>(
  items: T[],
  predefinedCategories: { value: string; name: string }[]
) {
  const result = R.uniq(
    R.concat(
      R.map((c) => c.value, predefinedCategories),
      R.flatten(R.map((item) => item.category || item.categories || [], items))
    )
  )

  return R.pipe(
    R.reject(R.isNil),
    R.map(R.trim),
    R.reject(R.isEmpty),
    R.map(R.pipe(R.when(R.is(Number), R.toString))),
    R.uniq,
    R.sort((a: string, b: string) => a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' })),
    R.map((c) => ({ value: c, label: predefinedCategories.find((cat) => cat.value === c)?.name || c }))
  )(result)
}
